import { connect } from '@vfde-sails/core';
import * as mapDispatch from 'Container/App/action';
import { DiscountHtmlId } from '../../enums/elementId';
import { selectors as mapStateToProps } from 'Container/App/selector';
import { mountOptionPicker, updateGigakombiPicker } from '../../components/optionPicker';
import { trackGigakombi } from '../../util/tracking';
import { updatePageUrl } from '../../util/url';
import { mountGigakombiDiscountCardTooltip } from '../../components/tooltip';
import { getUpdateFlags } from './update';
import { toggleElementVisibilityById } from '@vfde-brix/ws10/core';
import { mountPromotionalCard, updatePromotionalCard } from '../../components/promotionalCard';
import { getCMSConfig } from '../../util/cms';
import { GELB_GRAU, NVD, ORANGE, VFDE, VVM } from 'Container/AvailabilityCheck/constants';
import { PromotionalCard } from '@vfde-brix/ws10/promotional-card';
import { mapFiberWholeBuyPromotionalCardConfig } from '../../util/authApi/mappingHelper';
import { formatRolloutText } from '../../util/formatter';

export type State = ReturnType<typeof mapStateToProps>;
type Actions = typeof mapDispatch;

/**
 * update promotionalCard props based availability indicator
 */
function updatePromCardPropsBasedOnAVI (promotionalCard: PromotionalCard | null,
    availabilityIndicator?: string,
    rolloutEndMonth?: string,
    accessSupplier?: string) {
    const cmsConfig = getCMSConfig();
    const currentCmsConfig = accessSupplier ? mapFiberWholeBuyPromotionalCardConfig(cmsConfig,
        accessSupplier) : null;
    const labelMapping: { [key: string]: 'VVM' | 'NVD' } = {
        [GELB_GRAU]: VVM,
        [ORANGE]: NVD,
    };

    let labelKey: 'VVM' | 'NVD' | null = labelMapping[availabilityIndicator || ''];

    if (labelKey){
        const dateText = formatRolloutText(labelKey, rolloutEndMonth, currentCmsConfig);
        labelKey && updatePromotionalCard(promotionalCard, {
            stdSystemIconName: currentCmsConfig?.[labelKey]?.icon,
            stdLabel: currentCmsConfig?.[labelKey]?.label,
            txtSublabel: dateText + currentCmsConfig?.[labelKey]?.subLabel,
        });
        labelKey && toggleElementVisibilityById(DiscountHtmlId.PROMOTIONAL_INFO_CARD, true);
    } else {
        toggleElementVisibilityById(DiscountHtmlId.PROMOTIONAL_INFO_CARD, false);
    }

};

function container (_: State, actions: Actions) {
    const gigakombiPicker = mountOptionPicker(DiscountHtmlId.GIGAKOMBI_PICKER, (value: string) =>
        actions.setGigakombi('true' === value));

    mountGigakombiDiscountCardTooltip();

    const promotionalCard = mountPromotionalCard(DiscountHtmlId.PROMOTIONAL_INFO_CARD);

    return {
        getDerivedStateFromProps(newState: State, oldState: State) {
            const {
                gigakombi,
                selected,
                contentEnabled,
                accessSupplier,
                availabilityIndicator,
                rolloutEndMonth,
            } = newState;
            const update = getUpdateFlags(newState, oldState);

            if (accessSupplier && accessSupplier !== VFDE){
                updatePromCardPropsBasedOnAVI(promotionalCard, availabilityIndicator,
                    rolloutEndMonth, accessSupplier);
            } else {
                toggleElementVisibilityById(DiscountHtmlId.PROMOTIONAL_INFO_CARD, false);
            }

            if (update.gigakombiPicker) {
                updateGigakombiPicker(gigakombiPicker, gigakombi, contentEnabled);
                toggleElementVisibilityById(DiscountHtmlId.GIGAKOMBI_PICKER_TEXT, gigakombi);
            }

            update.gigakombiChosen && trackGigakombi(selected.tariff!);
            update.gigakombiChanged && updatePageUrl(gigakombi, selected.tariffId);
        },
    };
}

export default connect(mapStateToProps, mapDispatch)(container);
